app.controller("PropertyFollowerFormController",
	["$scope", "$http", "$window", function($scope, $http, $window) {
		$scope.sendingForm = false;
		$scope.submitted = false;

		$scope.submitForm = function() {
			var errors = {
				firstName: 'Syötä etunimesi',
				lastName: 'Syötä sukunimesi',
				email: 'Virheellinen sähköpostiosoite',
				phone: 'Syötä puhelinnumero'
			};
			if ($scope.errors == null) {
				$scope.errors = [];
			}

			$scope.sendingForm = true;

			var propertyFollowerData = {
				property: $scope.property,
				email: $scope.email,
				firstName: $scope.firstName,
				lastName: $scope.lastName,
				phone: $scope.phone,
				streetAddress: $scope.streetaddress,
				postCode: $scope.postcode,
				city: $scope.city,
				visited: $scope.visited,
				message: $scope.message
			};
			if ($window.wakeTestEmail !== undefined) {
				propertyFollowerData.wakeTestEmail = $window.wakeTestEmail;
			}

			$http({
				method: "POST",
				url: "/api/km/KMSite/PropertyFollower",
				data: propertyFollowerData
			})
			.then(function(data) {
				$scope.errors = [];
				$scope.sendingForm = false;
				$scope.submitted = true;

				$scope.thank_you = 'Kiitos, sinut on lisätty tämän tarjouskauppakohteen seuraajaksi!';
				_gaq.push(['_trackEvent', 'Seuraa kohdetta', 'Lähetä']);
			}, 
			function(results) {
				console.log(results.data);
				$scope.sendingForm = false;
				
				for (var key in results.data.data) {
					if(!results.data.data[key].success) {
						$scope.errors[key] = errors[key];
					} else {
						$scope.errors[key] = null;
					}
				}
			});
		};
	}]
);